$('.confirmation').hide().css({'opacity':'1'});

$(document).ready(function(){
    for (i = 1; i <= $('#gallery').data('images'); i++) {
        var page = Math.ceil(i/15);
		if (i < 67) {
			var caption = 'Plantare Bucium - Aprilie';
		} else {
			var caption = 'Plantare Tătaru - Aprilie';
		}
        $('#gallery').append('<a href="/assets/gallery/plantare-2019/'+i+'.jpg" class="page'+page+'" data-sub-html="'+caption+'"><img src="/assets/gallery/plantare-2019/thumbs/'+i+'.jpg" class="img-responsive" alt="" /></a>');
    }
    var pages = Math.ceil($('#gallery').data('images')/15);
    for (i = 1; i <= pages; i++) {
        $('#gallery-pagination ul').append('<li><a role="button">'+i+'</a></li>');
        if (i == 1) {
            //showPage(i);
            $('#gallery-pagination ul li').first().find('a').addClass('active');
        }
    }
    $('#gallery').lightGallery({
        mode: 'lg-fade',
        thumbnail: true,
        download: false,
        autoplay: false,
        share: false
    });

	$('#videogallery').lightGallery({
		loadYoutubeThumbnail: true,
		youtubeThumbSize: 'mqdefault',
		youtubePlayerParams: {
			autoplay: 1,
			modestbranding: 1,
			showinfo: 0,
			rel: 0,
			controls: 1
		}
	});

    $('#gallery-pagination a').on('click',function(){
        //showPage($(this).text());
        $('#gallery-pagination a.active').removeClass('active');
        $(this).addClass('active');
        $('#gallery a').hide();
        $('#gallery a.page'+$(this).text()).show();
    });

    function showPage(page){
        $('#gallery .page'+page+' img').each(function(){
            $(this).attr('src',$(this).data('src'));
        });
    }
});

$(window).on('load', function () {

	new TimelineMax({delay:0.5})
    	.fromTo(".sect1-sticla", 0.5, {x:'100%'}, {x:'0%', ease: Power2.easeOut})
		.staggerFromTo(".sect1 h1, .sect1 p", 1, {opacity:0, y:'-10%'}, {opacity:1, y:'0%', ease: Power2.easeOut, onComplete:function(){
			//$('h1 .blue').text('100.000');
		}},'0.25');

    $('body').scrollspy({target: ".plantare-nav", offset: 50});
    $(".inpage").on('click', function(event) {
        // Make sure this.hash has a value before overriding default behavior
        if (this.hash !== "") {
          event.preventDefault();
          scrollToSection(this.hash, 47, this.hash);
        }
      });

    $('.confirmation-close').on('click', function(){
        $('.confirmation').fadeOut();
    });

	$('form.plantare_register').on('submit', function (e) {
		if (e) e.preventDefault();
		if ($(this).data('submitting')) return false; //double submit

		$('.form-group', this).removeClass('has-error');
		$('.errors').slideUp().removeClass('has-errors');
		$('span.help-block', this).remove();
		$(this).data('submitting', true).addClass('submitting');
		$('button[type=submit]', this).button('loading');

		$.ajax({
			type: $(this).attr('method'),
			url: $(this).attr('action'),
			cache: false,
			context: this,
			data: $(this).serialize(),
			dataType: 'json',
			success: function (data) {
				if (window.ga) {
					ga('send', 'pageview', '/plantare/editia2/succes');
				}
                grecaptcha.reset();
                $('.confirmation-text').hide();
                $('.confirmation-text-'+(data.status_code == 0 ? '1':'2')).show();
                $('.confirmation').fadeIn();
				$(this).trigger('reset');
			},
			error: function (xhr) {
				if (xhr.status == 422) {
					for (var field in xhr.responseJSON) {
						$('*[name=' + field + '], input[name=' + field + ']+label', this)
							.last()
							.after(
								function () {
									$errors = "";
									for (var err in xhr.responseJSON[field])
										$errors += '<span class="help-block">' + xhr.responseJSON[field][err] + '</span>';
									return $errors;
								}
							)
							.parents('.form-group:first').addClass('has-error');
					}
				} else if (xhr.status == 403) {
					console.log(xhr);
				}
			},
			complete: function(xhr) {
				$(this).data('submitting', false).removeClass('submitting');
				$('button[type=submit]',this).button('reset');
			}
		});
	});

});
